import React from 'react';
import * as stylex from '@stylexjs/stylex';
import SidebarNav from "nood-comp/src/comp/ui/nav/SidebarNav";
import EventProper_Index from "src/routes/event/events/EventProper_Index";
import EventCategoriesIndex from "src/routes/event/categories/EventCategoriesIndex";
import Text from "nood-comp/src/comp/text/Text";
export default function EventIndex(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarNav, {
    "default": "events",
    header: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, "Events")),
    menu: [{
      id: "events",
      content: /*#__PURE__*/React.createElement(EventProper_Index, null),
      icon: "calendar",
      title: "Events"
    }, {
      id: "categories",
      content: /*#__PURE__*/React.createElement(EventCategoriesIndex, null),
      icon: "grid",
      title: "Categories"
    }],
    queryStringFilter: "pg"
  }));
}

// @ts-ignore